// tr strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "Kartın reddedildi. Lütfen bankanla iletişime geç veya başka bir ödeme yöntemi dene.",
  "checkout.trialStarted": "Ücretsiz deneme süren başladı!",
  "checkout.thanks": "Satın aldığın için teşekkürler!",
  "checkout.startTrial": "Ücretsiz denemeyi başlat",
  "checkout.pay": "Öde",
};

export default checkout;
